import Header from "./components/Header.tsx";
import Home from "./components/Home";
import Contact from "./components/Contact.tsx";
import Destinations from "./components/Destinations";
import PlanDetail from "./components/PlanDetail";
import { LocaleProvider } from "./i18n/LocaleContext";
// import "./index.css";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

export function App() {
  return (
      <Router>
          <LocaleProvider>
              <div className="app-Container">
                  <Header></Header>
                  <main className="Content">
                      <Routes>
                          <Route path="/" element={<Home />} />
                          <Route path="/home" element={<Navigate to="/" replace />} />
                          <Route path="/destinos" element={<Destinations />} />
                          <Route path="/planes/:id" element={<PlanDetail />} />
                          <Route path="/contact" element={<Contact />} />
                          <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                  </main>

              </div>
          </LocaleProvider>
      </Router>
  );
}

export default App;
